function governedTimeZone(displayContext, participantTimeZone) {
  if (displayContext?.mode === "project_fixed") {
    return displayContext.timeZone || null;
  }
  if (displayContext?.mode === "participant_local") {
    return participantTimeZone || null;
  }
  return null;
}

export function formatGovernedDateTime(value, {
  locale,
  displayContext,
  participantTimeZone = null
} = {}) {
  if (!value || !locale) return null;
  const timeZone = governedTimeZone(displayContext, participantTimeZone);
  if (!timeZone) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone
    }).format(date);
  } catch {
    return null;
  }
}

export function formatGovernedDate(value, {
  locale,
  displayContext,
  participantTimeZone = null
} = {}) {
  if (!value || !locale) return null;
  const timeZone = governedTimeZone(displayContext, participantTimeZone);
  if (!timeZone) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone }).format(date);
  } catch {
    return null;
  }
}

export function temporalCopyTokens(temporalDelivery, options = {}) {
  const { resultRelease = null, ...formatOptions } = options;
  const deadline = temporalDelivery?.deadlines?.stage3;
  const window = temporalDelivery?.windows?.stage4;
  const displayContext = temporalDelivery?.displayContext || null;
  return {
    "Stage 3 deadline": deadline?.state === "configured"
      ? formatGovernedDateTime(deadline.deadlineAt, { ...formatOptions, displayContext })
      : null,
    "window opens": window && window.state !== "not_configured"
      ? formatGovernedDateTime(window.opensAt, { ...formatOptions, displayContext })
      : null,
    "window closes": window && window.state !== "not_configured"
      ? formatGovernedDateTime(window.closesAt, { ...formatOptions, displayContext })
      : null,
    "result release at": resultRelease?.releaseAt
      ? formatGovernedDateTime(resultRelease.releaseAt, { ...formatOptions, displayContext })
      : null,
  };
}

export function renderExactTokenizedCopy(template, tokens) {
  if (typeof template !== "string") return null;
  let unresolved = false;
  const rendered = template.replace(/\{([^{}]+)\}/g, (_match, token) => {
    const value = tokens?.[token];
    if (value === undefined || value === null || value === "") {
      unresolved = true;
      return "";
    }
    return String(value);
  });
  return unresolved || /\{[^{}]+\}/.test(rendered) ? null : rendered;
}
